module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_babel-runtime@6.26.0@babel-runtime/core-js/object/get-own-property-descriptor.js
// module id = 510
// module chunks = 0 1